import React, { useEffect, useMemo, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import styles from "./list.module.scss";
import { api } from "../../../../services";
import RowItem from "./row";
import SearchBar from "../../../../library/common/SearchBar/SearchBar";
import { CONSTANTS } from "../../../../library/common/constant";

const { ABOUT_US_TITLE, CREATE_ABOUT_US_TITLE, SEARCH_ABOUT_US_LABEL } =
  CONSTANTS;

const AboutUsList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [list, setList] = useState(null);

  const ITEMS_PER_PAGE = 6;

  const filteredData = useMemo(() => {
    let filterList = searchTerm
      ? list?.filter(
          (item) =>
            searchTerm &&
            (String(item?.heading)
              ?.toLowerCase()
              ?.includes(searchTerm?.toLowerCase()) ||
              String(item?.description)
                ?.toLowerCase()
                ?.includes(searchTerm?.toLowerCase()) ||
              String(item?.isImage)
                ?.toLowerCase()
                ?.includes(searchTerm?.toLowerCase()) ||
              String(item?.order)
                ?.toLowerCase()
                ?.includes(searchTerm?.toLowerCase()))
        )
      : list;
    return filterList?.length ? filterList : [];
  }, [list, searchTerm]);

  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const handlePageChange = (direction) => {
    if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    } else if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const getList = async () => {
    const response = await api.get("/aboutus");

    setList(response.data);
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className={styles.listing}>
      <Paper className={styles.listContainer}>
        <Box className={styles.headerBox}>
          <div className={styles.headerContent}>
            <Typography variant="h5" component="h2" className={styles.title}>
              {ABOUT_US_TITLE}
            </Typography>
            <Box display="flex" gap={4}>
              <div className={styles.searchInput}>
                <SearchBar
                  placeholderText={SEARCH_ABOUT_US_LABEL}
                  updateSearchText={handleSearch}
                />
              </div>
              <Button variant="contained" role="link" href="/about-us/add">
                {CREATE_ABOUT_US_TITLE}
              </Button>
            </Box>
          </div>
        </Box>

        <Box className={styles.tableContainer}>
          <TableContainer>
            <Table size="medium">
              <TableHead>
                <TableRow>
                  <TableCell className={styles.tableCellImage}>Asset</TableCell>
                  <TableCell>Heading</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Is Image</TableCell>
                  <TableCell>Order</TableCell>
                  <TableCell className={styles.tableCellActions}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentItems?.map((item, index) => (
                  <RowItem
                    key={`banner-${index}`}
                    item={item}
                    getList={getList}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className={styles.pagination}>
            <Typography className={styles.paginationText}>
              Showing {indexOfFirstItem + 1} to{" "}
              {Math.min(indexOfLastItem, filteredData.length)} of{" "}
              {filteredData.length} entries
            </Typography>
            <div className={styles.pageButtons}>
              <IconButton
                onClick={() => handlePageChange("prev")}
                disabled={currentPage === 1}
                size="small"
              >
                <ChevronLeft />
              </IconButton>
              <IconButton
                onClick={() => handlePageChange("next")}
                disabled={currentPage === totalPages}
                size="small"
              >
                <ChevronRight />
              </IconButton>
            </div>
          </Box>
        </Box>
      </Paper>
    </div>
  );
};

export default AboutUsList;
